import { render } from "./DaftarPengajuan.vue?vue&type=template&id=036a5a86"
import script from "./DaftarPengajuan.vue?vue&type=script&lang=js"
export * from "./DaftarPengajuan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__